import { cn } from "@theprelude/core";

export const ArrowRight: React.FC<React.ComponentPropsWithoutRef<"svg">> = ({
  className,
  ...props
}) => (
  <svg
    className={cn("size-4 flex-shrink-0", className)}
    {...props}
    viewBox="0 0 17 16"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M11.2814 8.66669L3.16669 8.66669L3.16669 7.33335L11.2814 7.33335L7.70536 3.75735L8.64803 2.81469L13.8334 8.00002L8.64802 13.1854L7.70536 12.2427L11.2814 8.66669Z" />
  </svg>
);
